import { isBrowser } from '../env';

export interface Locale {
  /** 语言标识 */
  value: string;
  /** 语言显示名称 */
  label: string;
  /** 显示的标识 */
  lang?: string;
  /** 语言中文名称 */
  name: string;
  /** 是否隐藏 */
  hidden?: [string];
  host?: string;
}

/** 默认语言 */

/** 全球站语言列表 cspell:disable */
export const ALL_LOCALES: Array<Locale> = [
  {
    value: 'en',
    lang: 'EN',
    label: 'English',
    name: '英语',
  },
  {
    value: 'id-ID',
    lang: 'ID',
    label: 'Bahasa Indonesia',
    name: '印尼语',
  },
  {
    value: 'es-ES',
    lang: 'ES',
    label: 'Español (Internacional)',
    name: '西班牙语',
  },
  {
    value: 'es-MX',
    lang: 'ES',
    label: 'Español (México)',
    name: '墨西哥西班牙语',
  },
  {
    value: 'es-AR',
    lang: 'ES',
    label: 'Español (Argentina)',
    name: '阿根廷西班牙语',
  },
  {
    value: 'fil-PH',
    lang: 'FIL',
    label: 'Filipinos',
    name: ' 菲律宾语',
  },
  {
    value: 'kk-KZ',
    lang: 'KK',
    label: 'қазақша',
    name: '哈萨克斯坦语',
  },
  {
    value: 'pl-PL',
    lang: 'PL',
    label: 'Polski',
    name: '波兰语',
  },
  {
    value: 'pt-BR',
    lang: 'BR',
    label: 'Português (Brasil)',
    name: '巴西葡萄牙语',
  },
  {
    value: 'pt-PT',
    lang: 'PT',
    label: 'Português (Portugal)',
    name: '葡萄牙语',
  },
  {
    value: 'ro-RO',
    lang: 'RO',
    label: 'Românǎ',
    name: '罗马尼亚语',
  },
  {
    value: 'ru-RU',
    lang: 'RU',
    label: 'Русский',
    name: '俄语',
  },
  {
    value: 'vi-VN',
    lang: 'VI',
    label: 'Tiếng Việt',
    name: '越南语',
  },
  {
    value: 'th-TH',
    lang: 'TH',
    label: 'ไทย',
    name: '泰语',
  },
  {
    value: 'uk-UA',
    lang: 'UK',
    label: 'Українська',
    name: '乌克兰语',
  },
  {
    value: 'ar-SA',
    lang: 'AR',
    label: 'العربيه',
    name: '阿拉伯语',
  },
  {
    value: 'ja-JP',
    lang: 'JA',
    label: '日本語',
    name: '日本语',
  },
  {
    value: 'zh-MY',
    lang: 'ZH',
    label: '中文（马来西亚）',
    name: '中文（马来西亚）',
  },
  {
    value: 'zh-TW',
    lang: 'ZH',
    label: '中文繁體',
    name: '中文繁体',
  },
  /** 香港站支持的语言 */
  {
    value: 'zh-HK',
    lang: 'ZH',
    label: '繁體中文（香港）',
    name: '繁體中文（香港）',
    host: '.hk',
    hidden: ['apex'],
  },
  {
    value: 'en-HK',
    lang: 'EN',
    label: 'English(Hong Kong)',
    name: '英语(香港)',
    host: '.hk',
    hidden: ['apex'],
  },
  /** 荷兰站支持的语言 */
  {
    value: 'en-NL',
    lang: 'EN',
    label: 'English (Netherlands)',
    name: '荷兰语(英文)',
    host: '.nl',
    hidden: ['apex'],
  },
  {
    value: 'nl-NL',
    lang: 'NL',
    label: 'Dutch',
    name: '荷兰语',
    host: '.nl',
    hidden: ['apex'],
  },
];

/** 不包含特殊定制的语言 */
export const NORMAL_LOCALES = ALL_LOCALES.filter((item) => !item.host);

export const RTL_LIST = ['ar-SA'];

/** 默认语言 */
export const DEFAULT_LOCALE = (() => {
  if (!isBrowser) return 'en';
  if (window.location.hostname.endsWith('.hk')) return 'zh-HK';
  if (window.location.hostname.endsWith('.nl')) return 'en-NL';
  return 'en';
})();

/** 支持的语言 */
export const LOCALES = (() => {
  if (!isBrowser) return ALL_LOCALES;
  if (window.location.hostname.endsWith('.hk'))
    return ALL_LOCALES.filter((v) => v.host === '.hk');
  if (window.location.hostname.endsWith('.nl'))
    return ALL_LOCALES.filter((v) => v.host === '.nl');
  return ALL_LOCALES.filter((v) => !v.host);
})();

/** localStorage 国际化标识，注意：其它业务在英文下是 `en` */
export const LOCALE_LS_KEY = 'BYBIT_LANG_KEY';

export const I18N_URL =
  'https://fh-static.bycsi.com/i18n-upload/low-cache/project/release';
